<template>
    <component
        :is="component"
        v-if="component"
        :note="note"
        :locked="true"
        :pageWidth="pageWidth"
        :pageHeight="pageHeight"
        :selectedScale="selectedScale"
        :selectedElement="selectedElement"
        :totalPages="totalPages"
    />
</template>
<script>
export default {
    name: 'dynamic-note-template',
    props: [
        'note',
        'pageWidth',
        'pageHeight',
        'totalPages',
        'selectedElement'
    ],
    data() {
        return {
            component: null,
            selectedScale: localStorage.getItem('page-print-scale') || 1
        };
    },
    computed: {
        loader() {
            if (!this.note.type) {
                return () => Promise.reject();
            }
            return () => import(`./templates/${this.note.type}`);
        }
    },
    mounted() {
        this.loader()
            .then(() => {
                this.component = () => this.loader();
            })
            .catch(() => {
                this.component = () => import('./templates/text');
            });
    }
};
</script>


// WEBPACK FOOTER //
// wrapper.vue?0ee35af6